import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { DEFAULT_LOGOS, useOperators } from "@/components/mobile/operators";
import { OperatorMark } from "@/components/mobile/OperatorLogo";
import { STATUS, TYPE } from "@/pages/DealerItaliaMobile";
import { ChevronRight } from "lucide-react";

const day = (s) => { try { return new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" }); } catch { return ""; } };

const SimRow = ({ s }) => (
  <Link to={`/app/mobile/${s.key}?tab=ordina`} className="flex items-center gap-3 rounded-lg px-2 py-1.5 transition-colors hover:bg-secondary" data-testid={`dash-sim-${s.key}`}>
    <OperatorMark op={s} />
    <span className="flex-1 min-w-0 truncate text-sm">{s.name}</span>
    <strong className={`text-lg ${s.low ? "text-amber-600" : ""}`} data-testid={`dash-sim-count-${s.key}`}>{s.stock}</strong>
    <span className="text-xs text-muted-foreground">SIM</span>
  </Link>
);

const ReqRow = ({ r, op }) => {
  const st = STATUS[r.status] || { label: r.status, cls: "" };
  return (
    <Link to={`/app/console-sim?tab=${r.operator}`} className="flex items-center gap-3 rounded-lg px-2 py-1.5 transition-colors hover:bg-secondary" data-testid={`dash-req-${r.id}`}>
      <OperatorMark op={op} testid={`dash-req-logo-${r.id}`} />
      <span className="flex-1 min-w-0 truncate text-sm"><strong className="font-medium">{TYPE[r.request_type] || r.request_type}</strong> · {[r.nome, r.cognome].filter(Boolean).join(" ") || r.phone_number || `#${r.id.slice(-6)}`}</span>
      <span className="hidden sm:inline text-xs text-muted-foreground">{day(r.created_at)}</span>
      <Badge className={`${st.cls} text-[11px]`}>{st.label}</Badge>
    </Link>
  );
};

export const DealerMobileSummary = () => {
  const ops = useOperators();
  const [sims, setSims] = useState(null);
  const [reqs, setReqs] = useState(null);
  useEffect(() => {
    api.get("/sim-stock/counts").then((r) => setSims(r.data.items || [])).catch(() => setSims([]));
    api.get("/italiamobile/requests", { params: { limit: 5 } }).then((r) => setReqs(r.data || [])).catch(() => setReqs([]));
  }, []);
  if (!sims || !reqs || (!sims.length && !reqs.length)) return null;
  const opOf = (r) => (ops || []).find((o) => o.key === r.operator) || sims.find((s) => s.key === r.operator) || { key: r.operator, name: r.operator_name, logo: DEFAULT_LOGOS[r.operator] };
  return (
    <Card className="p-4 grid gap-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)]" data-testid="dealer-mobile-summary">
      <div className="space-y-2">
        <div className="flex items-center justify-between"><h2 className="font-head text-base font-semibold">Le tue SIM</h2><Link to="/app/ordina-sim" className="text-xs text-primary hover:underline" data-testid="dash-sim-order">Ordina SIM</Link></div>
        {sims.length ? sims.map((s) => <SimRow key={s.key} s={s} />) : <p className="text-sm text-muted-foreground">Nessun operatore SIM attivo.</p>}
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between"><h2 className="font-head text-base font-semibold">Ultime pratiche mobile</h2><Link to="/app/console-sim" className="inline-flex items-center text-xs text-primary hover:underline" data-testid="dash-req-all">Vedi tutte<ChevronRight className="w-3.5 h-3.5" /></Link></div>
        {reqs.length ? reqs.map((r) => <ReqRow key={r.id} r={r} op={opOf(r)} />) : <p className="text-sm text-muted-foreground" data-testid="dash-req-empty">Ancora nessuna pratica.</p>}
      </div>
    </Card>
  );
};
